import { savedOrderDetailsOrderInformationStyles as styles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.orderDateTitle = {
    ...styles.orderDateTitle,
    variant: "h4",
};

styles.orderDateText = {
    ...styles.orderDateText,
    css: css`
        ${styles.orderDateText?.css}
        line-height: 180%;
        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};

styles.shippingAddressTitle = {
    ...styles.shippingAddressTitle,
    variant: "h3",
    css: css`
        ${styles.shippingAddressTitle?.css}
        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};

styles.billingAddressTitle = {
    ...styles.billingAddressTitle,
    variant: "h3",
    css: css`
        ${styles.billingAddressTitle?.css}
        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};

styles.mainInformationGridItem = {
    ...styles.mainInformationGridItem,
    css: css`
        ${styles.mainInformationGridItem?.css}
        padding-bottom: 40px;
        ${mediaQueriesBP.maxMD} {
            padding-bottom: 24px;
        }
    `,
};

styles.shippingAddress = {
    ...styles.shippingAddress,
    wrapper: {
        ...styles.shippingAddress?.wrapper,
        css: css`
            ${mediaQueriesBP.maxMD} {
                padding-bottom: 24px;
            }
        `,
    },
    address1Text: {
        ...styles.shippingAddress?.address1Text,
        css: css`
            ${styles.shippingAddress?.address1Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    customerNameText: {
        ...styles.shippingAddress?.customerNameText,
        css: css`
            ${styles.shippingAddress?.customerNameText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    attentionText: {
        ...styles.shippingAddress?.attentionText,
        css: css`
            ${styles.shippingAddress?.attentionText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    companyNameText: {
        ...styles.shippingAddress?.companyNameText,
        css: css`
            ${styles.shippingAddress?.companyNameText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    address2Text: {
        ...styles.shippingAddress?.address2Text,
        css: css`
            ${styles.shippingAddress?.address2Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    address3Text: {
        ...styles.shippingAddress?.address3Text,
        css: css`
            ${styles.shippingAddress?.address3Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    address4Text: {
        ...styles.shippingAddress?.address4Text,
        css: css`
            ${styles.shippingAddress?.address4Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    cityStatePostalCodeText: {
        ...styles.shippingAddress?.cityStatePostalCodeText,
        css: css`
            ${styles.shippingAddress?.cityStatePostalCodeText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    countryText: {
        ...styles.shippingAddress?.countryText,
        css: css`
            ${styles.shippingAddress?.countryText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    phoneText: {
        ...styles.shippingAddress?.phoneText,
        css: css`
            ${styles.shippingAddress?.phoneText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    emailText: {
        ...styles.shippingAddress?.emailText,
        css: css`
            ${styles.shippingAddress?.emailText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    faxText: {
        ...styles.shippingAddress?.faxText,
        css: css`
            ${styles.shippingAddress?.faxText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
};

styles.billingAddress = {
    ...styles.billingAddress,
    address1Text: {
        ...styles.billingAddress?.address1Text,
        css: css`
            ${styles.billingAddress?.address1Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    customerNameText: {
        ...styles.billingAddress?.customerNameText,
        css: css`
            ${styles.billingAddress?.customerNameText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    attentionText: {
        ...styles.billingAddress?.attentionText,
        css: css`
            ${styles.billingAddress?.attentionText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    companyNameText: {
        ...styles.billingAddress?.companyNameText,
        css: css`
            ${styles.billingAddress?.companyNameText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    address2Text: {
        ...styles.billingAddress?.address2Text,
        css: css`
            ${styles.billingAddress?.address2Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    address3Text: {
        ...styles.billingAddress?.address3Text,
        css: css`
            ${styles.billingAddress?.address3Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    address4Text: {
        ...styles.billingAddress?.address4Text,
        css: css`
            ${styles.billingAddress?.address4Text?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    cityStatePostalCodeText: {
        ...styles.billingAddress?.cityStatePostalCodeText,
        css: css`
            ${styles.billingAddress?.cityStatePostalCodeText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    countryText: {
        ...styles.billingAddress?.countryText,
        css: css`
            ${styles.billingAddress?.countryText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    phoneText: {
        ...styles.billingAddress?.phoneText,
        css: css`
            ${styles.billingAddress?.phoneText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    emailText: {
        ...styles.billingAddress?.emailText,
        css: css`
            ${styles.billingAddress?.emailText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
    faxText: {
        ...styles.billingAddress?.faxText,
        css: css`
            ${styles.billingAddress?.faxText?.css}
            line-height: 180%;
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }
        `,
    },
};
